document.querySelectorAll('.nx-menu-toggle').forEach(button=>{const nav=document.querySelector('.nx-navigation');button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));nav.classList.toggle('nx-is-open',open)});button.addEventListener('keydown',e=>{if(e.key==='Escape'){button.setAttribute('aria-expanded','false');nav.classList.remove('nx-is-open')}});nav.addEventListener('keydown',e=>{if(e.key==='Escape'){button.setAttribute('aria-expanded','false');nav.classList.remove('nx-is-open');button.focus()}})});
(() => {
  const root = document.querySelector('.nx-carousel');
  if (!root) return;
  const slides = [...root.querySelectorAll('.nx-hero-slide')], tabs = [...root.querySelectorAll('[data-slide]')], pause = root.querySelector('.nx-carousel-pause');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)'), duration = 6500;
  let current = 0, touch = null, elapsed = 0, last = 0, frame = null, paused = reduce.matches, hover = false, visible = true;
  const playing = () => !paused && !hover && visible && !document.hidden && !root.contains(document.activeElement);
  function label() { pause.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); pause.textContent = paused ? '▶' : 'Ⅱ'; }
  function show(index, manual = false) {
    current = (index + slides.length) % slides.length; elapsed = 0;
    slides.forEach((slide, i) => { slide.hidden = i !== current; });
    tabs.forEach((tab, i) => { tab.setAttribute('aria-pressed', String(i === current)); tab.querySelector('.nx-timer-fill').style.transform = 'scaleX(0)'; });
    if (manual) root.querySelector('.nx-slide-status').textContent = `Slide ${current + 1} of ${slides.length}: ${tabs[current].getAttribute('aria-label').replace('Show ', '')}`;
  }
  function sync() {
    if (playing() && frame === null) { last = performance.now(); frame = requestAnimationFrame(tick); }
    else if (!playing() && frame !== null) { cancelAnimationFrame(frame); frame = null; }
  }
  function tick(now) {
    frame = null;
    if (!playing()) return;
    elapsed += Math.min(now - last, 100); last = now;
    if (elapsed >= duration) show(current + 1);
    tabs[current].querySelector('.nx-timer-fill').style.transform = `scaleX(${elapsed / duration})`;
    frame = requestAnimationFrame(tick);
  }
  tabs.forEach((tab, i) => tab.addEventListener('click', () => show(i, true)));
  pause.addEventListener('click', () => { paused = !paused; label(); sync(); });
  root.addEventListener('mouseenter', () => { hover = true; sync(); });
  root.addEventListener('mouseleave', () => { hover = false; sync(); });
  root.addEventListener('focusin', sync);
  root.addEventListener('focusout', () => queueMicrotask(sync));
  document.addEventListener('visibilitychange', sync);
  reduce.addEventListener('change', () => { if (reduce.matches) { paused = true; label(); sync(); } });
  if ('IntersectionObserver' in window) new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }).observe(root);
  root.addEventListener('keydown', event => {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1), true); tabs[current].focus();
  });
  root.addEventListener('touchstart', event => { touch = {x:event.changedTouches[0].clientX, y:event.changedTouches[0].clientY}; }, {passive:true});
  root.addEventListener('touchend', event => {
    if (!touch) return;
    const dx = event.changedTouches[0].clientX - touch.x, dy = event.changedTouches[0].clientY - touch.y;
    if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1), true);
    touch = null;
  }, {passive:true});
  label(); sync();
})();
